import Icon from '../components/Icon.vue'

Icon.register({"table":{"width":512,"height":512,"paths":[{"d":"M464 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H464C490.5 480 512 458.5 512 432V80C512 53.5 490.5 32 464 32zM224 416H64V320H224V416zM224 256H64V160H224V256zM448 416H288V320H448V416zM448 256H288V160H448V256z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/table.js
// module id = BEf1
// module chunks = 0